export default "__VITE_ASSET__DG1oVwHE__"